<template>
    <div
        class="app-steps">
        <slot :active="active"/>
    </div>
</template>

<script>
export default {
    name: 'app-steps',
    props: {
        active: Number
    },
    data() {
        return {
            steps: []
        }
    },
    watch: {
        steps(steps) {
            steps.forEach((child, index) => {
                child.index = index;
            });
        }
    }
    
}
</script>

<style lang="stylus">
    .app-steps
        margin-top: 15px
        margin-bottom: -10px
        display: -webkit-box
        display: -ms-flexbox
        display: flex
        white-space: nowrap
        justify-content: center
</style>